/**
 * External Imports
 */
import { FC, useMemo } from 'react';
import { format, sub } from 'date-fns';

/**
 * Nexus Imports
 */
import { NeuInput } from '@neutron/react';

/**
 * Internal Imports
 */
import { DateContainer, SelectContainer } from './MonthSelectsSection.styles';

const MonthSelectsSection: FC<{
  month: string;
  style?: {};
  handleSelects: (e: any) => void;
}> = ({ month, style, handleSelects }) => {
  const minMonth = useMemo(
    () => format(sub(new Date(), { years: 2 }), 'yyyy-MM'),
    []
  );
  const maxMonth = useMemo(() => format(new Date(), 'yyyy-MM'), []);

  return (
    <DateContainer id="Reports-Month-Selection" style={style}>
      <SelectContainer>
        <NeuInput
          id="Reports-Month-Selection-Start-Day"
          label="Month"
          name="month"
          type={'month' as any}
          autocomplete="off"
          inputMode="search"
          autoCorrect="off"
          onNeuChange={handleSelects}
          required
          value={month}
          min={minMonth}
          max={maxMonth}
          style={{ gap: 0 }}
        />
      </SelectContainer>
    </DateContainer>
  );
};

export default MonthSelectsSection;
